import React from "react";
import DeepScalperImage from "../assets/DeepScalper.jpg";
import KDD23 from "../assets/KDD23.jpg";
import RPRUDEXCompassImage from "../assets/RPRUDEX-Compass.png";
import wealthGraphImage from "../assets/wealthGraph.jpg";
import surveyImage from "../assets/surveyImage.jpg";
import externalLinkIcon from "../assets/icons8-external-link.svg";
import RL4QT from "../assets/RL4QT.jpg";
import "../styles/Research.css";
import banner from "../assets/b1.jpg";
export default function Reserach() {
  return (
    <div>


      <div className="" style={{width:'1200px',margin:"0 auto"}}>
        <div className="main1" style={{marginTop:'30px'}}>
          Research Papers
        </div>
      </div>

      <div style={{width:'1200px',margin:"30px auto",marginBottom:'100px'}}>
        {/* <h3 className="research-header">Research Papers</h3> */}

        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Molei Qin, Xinyu Cai, Yewen Li, Haochong Xia, Chuqiao Zong, Shuo Sun, Xinrun Wang, Bo An.
              <strong> FineFT: Efficient and risk-aware ensemble reinforcement learning for futures trading</strong>.
              <em> Proceedings of the 32nd ACM SIGKDD Conference on Knowledge Discovery and Data (<strong>KDD'26</strong>).</em>
              
            </p>

          </div>
        </div>

        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Haochong Xia, Simin Li, Ruixiao Xu, Zhixia Zhang, Hongxiang Wang, Zhiqian Liu, Teng Yao Long, Molei Qin, Chuqiao Zong, Bo An.
              <strong> Bayesian robust financial trading with adversarial synthetic market data</strong>.
              <em> Proceedings of the 32nd ACM SIGKDD Conference on Knowledge Discovery and Data (<strong>KDD'26</strong>).</em>
              
            </p>

          </div>
        </div>

        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Wentao Zhang, Yilei Zhao, Chuqiao Zong, Xinrun Wang, Bo An.
              <strong> FinWorld: An all-in-one open-source platform for end-to-end financial ai research and deployment</strong>.
              <em> Proceedings of the 32nd ACM SIGKDD Conference on Knowledge Discovery and Data (<strong>KDD'26</strong>).</em>
              
            </p>

          </div>
        </div>

        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Chuqiao Zong, Molei Qin, Haochong Xia, Bo An.
              <strong> ArchetypeTrader: Reinforcement learning for selecting and refining learnable strategic archetypes in quantitative trading</strong>.
              <em> Proceedings of the 40th AAAI Conference on Artificial Intelligence (<strong>AAAI'26</strong>).</em>
              
            </p>

          </div>
        </div>

        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Zeting Chen, Xinyu Cai, Molei Qin, Bo An.
              <strong> OPHR: Mastering volatility trading with multi-agent deep reinforcement learning</strong>.
              <em> Proceedings of the Thirty-ninth Annual Conference on Neural Information Processing Systems (<strong>NeurIPS'25</strong>).</em>

            </p>

          </div>
        </div>


        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Wentao Zhang, Lingxuan Zhao, Haochong Xia, Shuo Sun, Jiaze Sun, Molei Qin, Xinyi Li, Yuqing Zhao, Yilei Zhao, Xinyu Cai, Longtao Zheng, Xinrun Wang, Bo An.
              <strong> A multimodal foundation agent for financial trading: Tool-augmented, diversified, and generalist</strong>.
              <em> Proceedings of the 30th ACM SIGKDD Conference on Knowledge Discovery and Data (<strong>KDD'24</strong>).</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/KDD24_FinAgent.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>
        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Chuqiao Zong, Chaojie Wang, Molei Qin, Lei Feng, Xinrun Wang, Bo An.
              <strong> MacroHFT: Memory augmented context-aware reinforcement learning on high frequency trading</strong>.
              <em> Proceedings of the 30th ACM SIGKDD Conference on Knowledge Discovery and Data (<strong>KDD'24</strong>).</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/KDD24_MacroHFT.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>
        </div>
        

        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Wentao Zhang, Yilei Zhao, Shuo Sun, Jie Ying, Yonggang Xie, Zitao Song, Xinrun Wang, Bo An.
              <strong> Reinforcement learning with maskable stock representation for portfolio management in customizable stock pools</strong>.
              <em> Proceedings of the 2024 Web Conference (<strong>WWW'24</strong>).</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/WWW24_EarnMore.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>
        </div>


        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Molei Qin, Shuo Sun, Wentao Zhang, Haochong Xia, Xinrun Wang, Bo An.
              <strong> EarnHFT: Efficient hierarchical reinforcement learning for high frequency trading</strong>.
              <em> Proceedings of the 38th AAAI Conference on Artificial Intelligence (<strong>AAAI'24</strong>).</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/AAAI24_EarnHFT.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>
        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Haochong Xia, Shuo Sun, Xinrun Wang, Bo An.
              <strong> Market-GAN: Adding control to financial market data generation with semantic context</strong>.
              <em> Proceedings of the 38th AAAI Conference on Artificial Intelligence (<strong>AAAI'24</strong>).</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/AAAI24_MarketGAN.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>
        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Shuo Sun, Molei Qin, wentao zhang, Haochong Xia, Chuqiao Zong, Jie Ying, Yonggang Xie, Lingxuan Zhao, Xinrun Wang, Bo An.
              <strong> TradeMaster: A holistic quantitative trading platform empowered by reinforcement learning</strong>.
              <em> Proceedings of the Thirty-seventh Annual Conference on Neural Information Processing Systems (<strong>NeurIPS'23</strong>).</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/NeurIPS_23_TradeMaster.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>
        </div>


        <div className="row" style={{ marginTop: '20px' }}>
          {/*<div className="col align-self-center">*/}
          {/*  <div className="d-flex justify-content-center">*/}
          {/*    <img src={KDD23} alt="KDD23" style={{ maxHeight: "100%", maxWidth: "100%" }} />*/}
          {/*  </div>*/}
          {/*</div>*/}

          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p className="subtext" style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    Shuo Sun, Xinrun Wang, Wanqi Xue, Xiaoxuan Lou, Bo An. <strong> Mastering stock markets with efficient mixture of diversified trading experts.</strong> Proceedings of the 29th ACM SIGKDD Conference on Knowledge Discovery and Data (KDD'23), pp.2109-2119.          </p>*/}
          {/*  /!*<p className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>*!/*/}
          {/*  /!*  Shuo Sun, Xinrun Wang, Wanqi Xue, Xiaoxuan Lou, Bo An*!/*/}
          {/*  /!*</p>*!/*/}
          {/*  /!*<p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*!/*/}
          {/*  /!*  Proceedings of the 29th ACM SIGKDD Conference on Knowledge Discovery and Data (KDD'23), pp.2109-2119</p>*!/*/}
          {/*  <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/KDD23_Stock.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}




          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Shuo Sun, Xinrun Wang, Wanqi Xue, Xiaoxuan Lou, Bo An.
              <strong> Mastering stock markets with efficient mixture of diversified trading experts</strong>.
              <em> Proceedings of the 29th ACM SIGKDD Conference on Knowledge Discovery and Data (<strong>KDD'23</strong>), pp.2109-2119.</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/KDD23_Stock.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>




          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    Mastering Stock Markets with Efficient Mixture of Diversified Trading Experts*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>*/}
          {/*    Shuo Sun, Xinrun Wang, Wanqi Xue, Xiaoxuan Lou, Bo An*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*/}
          {/*    Proceedings of the 29th ACM SIGKDD Conference on Knowledge Discovery and Data (KDD'23), pp.2109-2119</p>*/}
          {/*  <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/KDD23_Stock.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}
        </div>



        <div className="row" style={{ marginTop: '20px' }}>
          {/*<div className="col align-self-center">*/}
          {/*  <div className="d-flex justify-content-center">*/}
          {/*    <img src={DeepScalperImage} alt="DeepScalperImage" style={{ maxHeight: "100%", maxWidth: "100%" }} />*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    DeepScalper: A Risk-Aware Reinforcement Learning Framework to Capture Fleeting Intraday Trading Opportunities*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>*/}
          {/*    Shuo Sun, Wanqi Xue, Rundong Wang, Xu He, Junlei Zhu, Jian Li, Bo An*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*/}
          {/*    Proceedings of the 31st ACM International Conference on Information and Knowledge Management (CIKM'22), pp.1858-1867</p>*/}
          {/*  <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/CIKM22_DeepScalper.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}

          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Shuo Sun, Wanqi Xue, Rundong Wang, Xu He, Junlei Zhu, Jian Li, Bo An.
              <strong> DeepScalper: A Risk-Aware Reinforcement Learning Framework to Capture Fleeting Intraday Trading Opportunities
              </strong>.
              <em> Proceedings of the 31st ACM International Conference on Information and Knowledge Management.
                (<strong>CIKM'22</strong>), pp.1858-1867.</em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/CIKM22_DeepScalper.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>


        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          {/*<div className="col align-self-center">*/}
          {/*  <div className="d-flex justify-content-center">*/}
          {/*    <img src={RPRUDEXCompassImage} alt="RPRUDEXCompassImage" style={{ maxHeight: "80%", maxWidth: "80%" }} />*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    PRUDEX-Compass: Towards Systematic Evaluation of Reinforcement Learning in Financial Markets*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>Shuo Sun, Molei Qin, Xinrun Wang, Bo An</p>*/}
          {/*  <p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*/}
          {/*    Transactions on Machine Learning Research (TMLR)</p>*/}
          {/*  <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/TMLR23-PRUDEX.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}


          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Shuo Sun, Molei Qin, Xinrun Wang, Bo An.
              <strong> PRUDEX-Compass: Towards Systematic Evaluation of Reinforcement Learning in Financial Markets</strong>.
              <em>Transactions on Machine Learning Research (TMLR).  </em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/TMLR23-PRUDEX.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>


        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          {/*<div className="col align-self-center">*/}
          {/*  /!*<div className="d-flex justify-content-center">*!/*/}
          {/*  /!*  <img src={wealthGraphImage} alt="wealthGraphImage" style={{ maxHeight: "100%", maxWidth: "100%" }} />*!/*/}
          {/*  /!*</div>*!/*/}
          {/*</div>*/}
          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    Commission Fee is not Enough: A Hierarchical Reinforced Framework for Portfolio Management*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>*/}
          {/*    Rundong Wang, Hongxin Wei, Bo An, Zhouyan Feng, Jun*/}
          {/*  Yao*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*/}
          {/*    Proceedings of the 35th AAAI Conference on Artificial Intelligence (AAAI'21), pp.626-633</p>*/}
          {/*  <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/AAAI21_Stock.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}

          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Rundong Wang, Hongxin Wei, Bo An, Zhouyan Feng, Jun.
              <strong> Commission Fee is not Enough: A Hierarchical Reinforced Framework for Portfolio Management</strong>.
              <em> Proceedings of the 35th AAAI Conference on Artificial Intelligence
                (<strong>AAAI'21</strong>), pp.626-633. </em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/AAAI21_Stock.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>


        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          {/*<div className="col align-self-center">*/}
          {/*  /!*<div className="d-flex justify-content-center">*!/*/}
          {/*  /!*  <img src={surveyImage} alt="surveyPaperImage" style={{ maxHeight: "100%", maxWidth: "100%" }} />*!/*/}
          {/*  /!*</div>*!/*/}
          {/*</div>*/}
          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    Reinforcement Learning for Quantitative Trading*/}
          {/*  </p>*/}
          {/*  <p className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>Shuo Sun, Rundong Wang, Bo An</p>*/}
          {/*  <p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*/}
          {/*    ACM Transactions on Intelligent Systems and Technology, Vol.14, No.3, pp.1-29, 2023*/}
          {/*  </p>*/}
          {/*  <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/TIST23_RLFintech.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}

          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Shuo Sun, Rundong Wang, Bo An.
              <strong> Reinforcement Learning for Quantitative Trading</strong>.
              <em> ACM Transactions on Intelligent Systems and Technology, Vol.14, No.3, pp.1-29, 2023.  </em>
              <a target="_blank" href="https://personal.ntu.edu.sg/boan/papers/TIST23_RLFintech.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>


        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          {/*<div className="col align-self-center">*/}
          {/*  /!*<div className="d-flex justify-content-center">*!/*/}
          {/*  /!*  <img src={RL4QT} alt="RL4QT" style={{ maxHeight: "100%", maxWidth: "100%" }} />*!/*/}
          {/*  /!*</div>*!/*/}
          {/*</div>*/}
          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    Deep Reinforcement Learning for Quantitative Trading: Challenges and Opportunities*/}
          {/*  </p>*/}
          {/*  <p  className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>Shuo Sun, Rundong Wang, Bo An</p>*/}
          {/*  <p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*/}
          {/*    IEEE Intelligent Systems, Vol.37, No.2, pp.23-26, 2022*/}
          {/*  </p>*/}
          {/*  <a className="subtext" target="_blank" href="https://personal.ntu.edu.sg/boan/papers/IEEEIS22RL.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}

          {/*<div className="col-md-6 col-lg-8 text col-text-center">*/}
          {/*  <p style={{ marginBottom: "0", fontSize: "16px" }}>*/}
          {/*    Deep Reinforcement Learning for Quantitative Trading: Challenges and Opportunities*/}
          {/*  </p>*/}
          {/*  <p  className="subtext" style={{ margin: "4px 0", fontSize: "14px" }}>Shuo Sun, Rundong Wang, Bo An</p>*/}
          {/*  <p className="subtext" style={{  marginTop: "0", marginBottom: "0", fontSize: "14px" }}>*/}
          {/*    IEEE Intelligent Systems, Vol.37, No.2, pp.23-26, 2022*/}
          {/*  </p>*/}
          {/*  <a className="subtext" target="_blank" href="https://personal.ntu.edu.sg/boan/papers/IEEEIS22RL.pdf" rel="noreferrer">*/}
          {/*    <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />*/}
          {/*  </a>*/}
          {/*</div>*/}

          <div className="col-12 text col-text-center">
            <p className="subtext" style={{ marginBottom: "0", fontSize: "18px" }}>
              Shuo Sun, Rundong Wang, Bo An.
              <strong> Deep Reinforcement Learning for Quantitative Trading: Challenges and Opportunities</strong>.
              <em> IEEE Intelligent Systems, Vol.37, No.2, pp.23-26, 2022.  </em>
              <a className="subtext" target="_blank" href="https://personal.ntu.edu.sg/boan/papers/IEEEIS22RL.pdf" rel="noreferrer">
                <img src={externalLinkIcon} alt="External link Icon" className="icon-link" />
              </a>
            </p>

          </div>

        </div>


      </div>
    </div>
  );
}
